export default ({
    state: {
        user: {
            sessionData: '',
            isAdmin: false,
            login: 'noname',
            displayName: 'Неизвестный пользователь',
            photo: '/noname.jpg',
        },
        interface: {
            theme: '',
            mode: 'light'
        }

    },

    mutations: {
        SET_SESSIONDATA(state, data) {
            state.user.login = data.login;
            state.user.sessionData = data.sessionData;
        },

        CLEAR_USER(state) {
            state.user.sessionData = '';
            state.user.isAdmin = false;
            state.user.displayName = '';
            state.user.photo = '';
        },

        SET_USERDATA(state, data) {
            state.user.isAdmin = data.isAdmin;
            state.user.displayName = data.displayName;
            state.user.photo = data.photo;
        },

        SET_INTERFACETHEME(state, data) {
            state.interface.theme = data.theme;
            state.interface.mode = data.mode;
        }
    },

    actions: {

    },

    getters: {
        sessionData: state => state.user.sessionData,
        isUserAuthenticated: state => state.user.sessionData !== '',
        isUserAdmin: state => state.user.isAdmin,
        userVisualData: state => {
            return {
                login: state.user.login,
                displayName: state.user.displayName,
                photo: state.user.photo,
            }
        },
        interfaceTheme: state => state.interface
    }
})